import { useDisplayGlucoseString } from "./useDisplayGlucoseString"

export function useReadableGlucoseString(value: number): string {
  const displayGlucoseString = useDisplayGlucoseString()
  return displayGlucoseString(value)
}
